module.exports = __webpack_public_path__ + "static/media/GBR Care infographic mobile 04-03-2024.78764efc.gif";